import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { QForm } from 'quasar';
import { ref } from 'vue';
import useValidation from 'SharedDir/common/composables/useValidation';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';

interface LoginData {
  login: string;
  password: string;
}

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'LoginForm' },
  __name: 'LoginForm',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {


const props = __props;
const emits = __emit;
const { NotEmpty } = useValidation();
const { innerValue, emitValue } = useValue(props, emits);
const isPasswordVisible = ref(false);
const refQForm = ref<QForm>(null as any);
const emitSubmit = () => {
  emits('submit');
};
const validate = () => refQForm.value.validate();

__expose({ validate });

return (_ctx: any,_cache: any) => {
  const _component_s_input = _resolveComponent("s-input")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(_unref(QForm), {
    ref_key: "refQForm",
    ref: refQForm,
    class: "column s-form",
    onSubmit: emitSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_s_input, {
        modelValue: _unref(innerValue).login,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue).login) = $event)),
          _unref(emitValue)
        ],
        label: "Логин",
        required: "",
        class: "q-mb-md s-input",
        rules: [_unref(NotEmpty)('Пожалуйста, введите Ваш Логин или Email')],
        onKeyup: _withKeys(emitSubmit, ["enter"])
      }, null, 8, ["modelValue", "rules", "onUpdate:modelValue"]),
      _createVNode(_component_s_input, {
        modelValue: _unref(innerValue).password,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_unref(innerValue).password) = $event)),
          _unref(emitValue)
        ],
        label: "Пароль",
        required: "",
        type: isPasswordVisible.value ? 'text' : 'password',
        rules: [_unref(NotEmpty)('Пожалуйста, введите Ваш пароль')],
        onKeyup: _withKeys(emitSubmit, ["enter"])
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: isPasswordVisible.value ? 'visibility_off' : 'visibility',
            class: "cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isPasswordVisible.value = !isPasswordVisible.value))
          }, null, 8, ["name"])
        ]),
        _: 1
      }, 8, ["modelValue", "type", "rules", "onUpdate:modelValue"]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 512))
}
}

})